import { Link } from "react-router-dom";
import Logo, { LogoMark } from "@/components/Logo";
import { FIRM, SERVICES } from "@/data/site";

const NAV = [
  { to: "/", label: "Home", id: "home" },
  { to: "/about", label: "About Us", id: "about" },
  { to: "/services", label: "Our Services", id: "services" },
  { to: "/insights", label: "Insights", id: "insights" },
  { to: "/contact", label: "Contact Us", id: "contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-navy-deep text-white" data-testid="site-footer">
      <div className="grain absolute inset-0" aria-hidden="true" />
      <div className="relative">
        <div className="container-x grid gap-14 py-20 sm:grid-cols-2 lg:grid-cols-[1.35fr_0.75fr_0.95fr_1.1fr] lg:gap-10 lg:py-24">
          <div>
            <Logo light />
            <p className="mt-7 max-w-sm text-[15px] leading-relaxed text-white/60">
              Established in 2002, a trusted partner in business software
              reselling and ERP implementation, alongside management
              consultancy, accounting, audit and tax services.
            </p>
          </div>

          <nav aria-label="Footer navigation">
            <h2 className="eyebrow-navy !text-gold">Navigate</h2>
            <ul className="mt-6 space-y-3.5">
              {NAV.map((l) => (
                <li key={l.id}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.id}`}
                    className="text-[15px] text-white/70 transition-colors hover:text-gold"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Footer services">
            <h2 className="eyebrow-navy !text-gold">Services</h2>
            <ul className="mt-6 space-y-3.5">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/services#${s.anchor}`}
                    data-testid={`footer-link-service-${s.anchor}`}
                    className="text-[15px] text-white/70 transition-colors hover:text-gold"
                  >
                    {s.short}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="eyebrow-navy !text-gold">Contact</h2>
            <ul className="mt-6 space-y-3.5 text-[15px] text-white/70">
              <li className="flex flex-wrap items-center gap-x-3 gap-y-2">
                <a
                  href={FIRM.phoneHref}
                  data-testid="footer-phone"
                  className="whitespace-nowrap transition-colors hover:text-gold"
                >
                  {FIRM.phone}
                </a>
                <span aria-hidden="true" className="text-white/30">·</span>
                <a
                  href={FIRM.phone2Href}
                  data-testid="footer-phone-2"
                  className="whitespace-nowrap transition-colors hover:text-gold"
                >
                  {FIRM.phone2}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${FIRM.email}`}
                  data-testid="footer-email"
                  className="transition-colors hover:text-gold"
                >
                  {FIRM.email}
                </a>
              </li>
              <li>
                <a
                  href={FIRM.addressHref}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-address"
                  className="transition-colors hover:text-gold"
                >
                  {FIRM.addressOneLine}
                </a>
              </li>
              <li className="pt-2 text-sm text-white/45">
                {FIRM.hours}
                <br />
                8:00 AM–5:00 PM WAT
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="container-x flex flex-col items-start justify-between gap-6 py-8 sm:flex-row sm:items-center">
            <p className="text-[13px] text-white/45" data-testid="footer-copyright">
              © {year} Steven Philips &amp; Associates Limited ({FIRM.rc}). All
              Rights Reserved.
            </p>
            <div className="flex items-center gap-8">
              <Link
                to="/privacy"
                data-testid="footer-link-privacy"
                className="text-[13px] uppercase tracking-[0.12em] text-white/45 transition-colors hover:text-gold"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                data-testid="footer-link-terms"
                className="text-[13px] uppercase tracking-[0.12em] text-white/45 transition-colors hover:text-gold"
              >
                Terms of Use
              </Link>
              <LogoMark className="h-7 w-auto opacity-80" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
